import React from 'react'
import Studentsettings from '../../components/student/studentsettings'
export default function Setting() {
  return (
    <div>
        <Studentsettings/>
    </div>
  )
}
